import { Controller } from 'stimulus'
import Rails from '@rails/ujs'
import { useDispatch } from 'stimulus-use'
import { useBusItem } from './mixins/useBusItem.js'

export default class extends Controller {
  static targets = ['form']

  static values = {
    model: String,
    entityIds: Array,
    busItemId: String
  }

  connect() {
    useDispatch(this)
    useBusItem(this)
  }

  triggerAddTags() {
    const data = new FormData(this.formTarget)
    const entityIds = this.entityIds()
    entityIds.map(entityId => data.append('tags_collection[entity_ids][]', entityId))
    entityIds.map(entityId => data.append(
      `tags_collection[entity_names][${[data.get('tags_collection[entity_type]'), entityId].filter(x => x !== null).join('-')}]`,
      document.querySelector(`[data-reference-id="${entityId}"]`).dataset.referenceName)
    )

    if (entityIds.length > 0) {
      Rails.ajax({
        type: 'post',
        url: '/tags_collections',
        data: data,
        success: () => this.handleSuccess(entityIds),
        error: () => alert('Something went wrong')
      })
    }
  }

  entityIds() {
    return this.entityIdsValue.length > 0 ? this.entityIdsValue : this.entitySelectController().entityIds
  }

  entitySelectController() {
    return this.application.getControllerForElementAndIdentifier(
      this.entitySelectContainer(), 'entity-select'
    )
  }

  entitySelectContainer() {
    return document.querySelector('[data-controller~="entity-select"]')
  }

  uncheckAll() {
    this.entitySelectController().uncheckAll()
  }

  handleSuccess(updatedEntityIds) {
    this.dispatch('tagsAdded', { model: this.modelValue })

    updatedEntityIds.forEach((entityId) => {
      this.dispatch(`${entityId}:tagsAdded`, { model: this.modelValue })
    })
  }
}
